/**
 * Title: API End points for Critical Process
 * Description: API End points for Critical Process
 * Author: Iqbal Hossain
 * Date: 10-January-2022
 * Modified: 10-January-2022
 **/

export const CRITICAL_PROCESS_API = {
  root: '/api/critical-process',
  fetch_all: 'api/critical-process/fetch-all',
  fetch_by_query: `/api/critical-process/fetch-by-query`,
  fetch_by_id: `/api/critical-process/fetch-by-id`,
  add: `/api/critical-process/add`,
  update: `/api/critical-process/update`,
  delete: `/api/critical-process/delete`,
  delete_by_range: `/api/critical-process/delete-range`
};
